<template>
    <DsModal
        class="decision-diamond-modal"
        :is-open="isOpen"
        :dialog="dialog"
        :show-close="showClose"
        :size="size"
        :title="title"
        @close="close"
    >
        <template #header>
            <section class="modal-right-controls">
                <DecisionDiamondsMenu
                    :show-debug-data-dump="showDebugDataDump"
                    @open-dd-debug-modal="showDebugDecisionDiamond"
                    @open-dd-test-modal="showTestDecisionDiamond"
                />
                <DsFilledButton data-qa="save-button" @click="saveDecisionDiamond">
                    {{ $t('global.save') }}
                </DsFilledButton>
            </section>
        </template>
        <template #default>
            <div class="diamond-configuration">
                <slot name="diamondParameters" />
            </div>
        </template>
    </DsModal>
</template>

<script>
import DecisionDiamondsMenu from './DecisionDiamondsMenu.vue';

export default {
    components: {
        DecisionDiamondsMenu,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        dialog: {
            type: Boolean,
            default: true,
        },
        size: {
            type: String,
            default: 'fullscreen',
        },
        showClose: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            required: true,
        },
        showDebugDataDump: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close-modal', 'update-config', 'open-dd-test-modal', 'open-dd-debug-modal'],
    methods: {
        close() {
            this.$emit('close-modal');
        },

        save() {
            this.$emit('update-config');
        },

        showTestDecisionDiamond() {
            this.$emit('open-dd-test-modal');
        },

        showDebugDecisionDiamond() {
            this.$emit('open-dd-debug-modal');
        },

        saveDecisionDiamond() {
            this.$emit('save-decision-diamond');
        },
    },
};
</script>
<style lang="scss" scoped>
.decision-diamond-modal {
    :deep(.modal-body-inner) {
        padding: $spacing-250;
    }
    :deep(.modal-body) {
        padding: 0;
    }
}

.modal-summary-text {
    margin-top: $spacing-050;
    line-height: $line-height-lg;
}

.modal-summary-label {
    font-size: $font-size-xs;
    color: $color-ink-800;
}

.modal-configuration {
    margin: $spacing-300 0 0 0;
}

.modal-tip {
    display: flex;
    padding: $spacing-150;
    border-radius: px-to-rem(8);
    flex-wrap: wrap;
    justify-items: left;
    background-color: $color-blue-050;
}

.modal-tip-icon {
    flex: 6%;
    color: $color-blue-300;
}

.modal-tip-text {
    margin-top: $spacing-025;
    flex: 94%;
    color: $color-ink-900;
}

.modal-tip-button {
    height: px-to-rem(32);
    margin-top: $spacing-100;
    padding: $spacing-100 $spacing-150 $spacing-100 $spacing-100;
    border-radius: px-to-rem(8);
    color: $color-ink-900;
    background-color: $color-ink-100;
}

.modal-right-controls {
    margin-right: $spacing-125;
    align-items: center;
    display: flex;
    justify-content: flex-end;
    grid-gap: $spacing-100;
}
</style>
